// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
// import '@/icons';
// import {
//   Input, Row, Col, Menu, MenuItem, MenuItemGroup, Button, Table, TableColumn, DatePicker, Pagination, Tabs, TabPane, Loading, Submenu,
//   Dialog, Form, FormItem, Divider, Upload,
// } from 'element-ui';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router';
import App from './App';
import './styles/common.less';
import store from './store';
import './utils/directive';

// Vue.config.productionTip = false;
// Vue.component(Input.name, Input);
// Vue.component(Row.name, Row);
// Vue.component(Col.name, Col);
// Vue.component(Menu.name, Menu);
// Vue.component(Submenu.name, Submenu);
// Vue.component(MenuItem.name, MenuItem);
// Vue.component(MenuItemGroup.name, MenuItemGroup);
// Vue.component(Button.name, Button);
// Vue.component(Table.name, Table);
// Vue.component(TableColumn.name, TableColumn);
// Vue.component(DatePicker.name, DatePicker);
// Vue.component(Pagination.name, Pagination);
// Vue.component(Tabs.name, Tabs);
// Vue.component(TabPane.name, TabPane);
// Vue.component(Dialog.name, Dialog);
// Vue.component(Form.name, Form);
// Vue.component(FormItem.name, FormItem);
// Vue.component(Divider.name, Divider);
// Vue.component(Upload.name, Upload);
// Vue.use(Loading.directive);

Vue.use(ElementUI);
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js